<div class="animate-in-from-left">
  <div class="d-flex align-items-center m-b-20">
    <button class="btn btn-transparent p-0">
      <fa-icon icon="arrow-left" class="circle-icon-btn" (click)="goBack()"></fa-icon>
      <span class="sr-only">{{ "order_detail.back" | translate }}</span>
    </button>
    <span class="">{{ "order_detail.order_history" | translate }}</span>
  </div>
  <fui-heading [text]="order ? ('order_detail.order_number' | translate: { orderName: order.name }) : ('order_detail.loading' | translate)" [level]="1" fontSize="f8"></fui-heading>
  <div class="m-y-30">{{ "order_detail.placed_on" | translate }} {{ order.date | date: "MMMM Do, YYYY [at] hh:mma" }}</div>

  <div class="fui-order-details desktop-only">
    <div class="fui-orders-header">
      <div class="fui-orders-col grow">{{ "order_detail.product" | translate }}</div>
      <div class="fui-orders-col">{{ "order_detail.model_sku" | translate }}</div>
      <div class="fui-orders-col">{{ "order_detail.price" | translate }}</div>
      <div class="fui-orders-col tiny">{{ "order_detail.qty" | translate }}</div>
      <div class="fui-orders-col small">{{ "order_detail.total" | translate }}</div>
    </div>
    @for (item of order.items; track item) {
      <div class="fui-order-item" mode="button" tabindex="0">
        <div class="fui-orders-col grow">
          <div class="d-flex align-items-center">
            @if (item.image?.url) {
              <img [src]="item.image.url" [alt]="item.image.alt || item.title" class="m-r-10" style="width: 50px" />
            }
            <div class="flex-grow-1">
              <div class="bold">{{ item.title }}</div>
              <div class="text-muted">{{ item.variantTitle }}</div>
              @if (item.modshopSpecSheet) {
                <a [href]="item.modshopSpecSheet" target="_blank" class="d-block m-t-5">{{ "orders.view_spec_sheet" | translate }}</a>
              }
              @if (item.modshopSpecs?.length) {
                <ul class="m-t-5 m-b-0 p-l-15" style="list-style: disc">
                  @for (spec of specsExpanded[item.id] ? item.modshopSpecs : item.modshopSpecs.slice(0, 4); track spec) {
                    <li class="text-muted">{{ spec }}</li>
                  }
                </ul>
                @if (item.modshopSpecs.length > 4) {
                  <a class="cursor-pointer d-inline-block m-t-5" (click)="specsExpanded[item.id] = !specsExpanded[item.id]">
                    <fa-icon [icon]="specsExpanded[item.id] ? 'chevron-up' : 'chevron-down'"></fa-icon>
                    {{ specsExpanded[item.id] ? ("sphere.workspaces.show_less" | translate) : ("sphere.workspaces.show_more" | translate) }}
                    <fa-icon [icon]="specsExpanded[item.id] ? 'chevron-up' : 'chevron-down'"></fa-icon>
                  </a>
                }
              }
            </div>
          </div>
        </div>
        <div class="fui-orders-col">{{ item.sku }}</div>
        <div class="fui-orders-col">
          @if (item.discountAmount > 0) {
            <div>{{ item.total | currency: order.currency }}</div>
            <div class="text-muted" style="text-decoration: line-through">{{ item.price | currency: order.currency }}</div>
          } @else {
            {{ item.price | currency: order.currency }}
          }
        </div>
        <div class="fui-orders-col tiny">{{ item.quantity }}</div>
        <div class="fui-orders-col small">
          <div>{{ item.total | currency: order.currency }}</div>
          @if (item.refunded) {
            <div class="c-red">(-{{ item.total | currency: order.currency }})</div>
          }
        </div>
      </div>
    }
  </div>

  <div class="fui-order-details mobile-only">
    @for (item of order.items; track item) {
      <div>
        <div class="bold m-b-10">{{ "order_detail.product" | translate }}</div>
        <div class="d-flex align-items-center m-b-20">
          @if (item.image?.url) {
            <img [src]="item.image.url" [alt]="item.image.alt || item.title" class="m-r-10" style="width: 50px" />
          }
          <div class="flex-grow-1">
            <div class="bold">{{ item.title }}</div>
            <div class="text-muted">{{ item.variantTitle }}</div>
          </div>
        </div>
        @if (item.modshopSpecSheet) {
          <a [href]="item.modshopSpecSheet" target="_blank" class="d-block m-b-10">{{ "orders.view_spec_sheet" | translate }}</a>
        }
        @if (item.modshopSpecs?.length) {
          <ul class="m-b-5 p-l-15" style="list-style: disc">
            @for (spec of specsExpanded[item.id] ? item.modshopSpecs : item.modshopSpecs.slice(0, 4); track spec) {
              <li class="text-muted">{{ spec }}</li>
            }
          </ul>
          @if (item.modshopSpecs.length > 4) {
            <a class="cursor-pointer d-inline-block m-b-10" (click)="specsExpanded[item.id] = !specsExpanded[item.id]">
              <fa-icon [icon]="specsExpanded[item.id] ? 'chevron-up' : 'chevron-down'"></fa-icon>
              {{ specsExpanded[item.id] ? ("sphere.workspaces.show_less" | translate) : ("sphere.workspaces.show_more" | translate) }}
              <fa-icon [icon]="specsExpanded[item.id] ? 'chevron-up' : 'chevron-down'"></fa-icon>
            </a>
          }
        }
        <div class="d-flex justify-content-between m-b-5">
          <div class="bold">{{ "order_detail.price" | translate }}</div>
          <div>
            @if (item.discountAmount > 0) {
              <span>{{ item.total | currency: order.currency }}</span>
              <span class="text-muted m-l-5" style="text-decoration: line-through">{{ item.price | currency: order.currency }}</span>
            } @else {
              {{ item.price | currency: order.currency }}
            }
          </div>
        </div>
        <div class="d-flex justify-content-between m-b-5">
          <div class="bold">{{ "order_detail.quantity" | translate }}</div>
          <div>{{ item.quantity }}</div>
        </div>
        <div class="d-flex justify-content-between m-b-5">
          <div class="bold">{{ "order_detail.total" | translate }}</div>
          <div>
            {{ item.total | currency: order.currency }}
            @if (item.refunded) {
              <span class="c-red m-l-5">(-{{ item.total | currency: order.currency }})</span>
            }
          </div>
        </div>
        <hr class="m-y-20" />
      </div>
    }
  </div>

  <div class="fui-order-summary">
    <div class="d-flex justify-content-between m-b-20">
      <div>{{ "order_detail.subtotal" | translate }}</div>
      <div>{{ order.subtotal | currency: order.currency }}</div>
    </div>
    @if (shippingDiscount) {
      <div class="d-flex justify-content-between m-b-20">
        <div>
          @if (shippingDiscount.translationKey) {
            {{ shippingDiscount.translationKey | translate: shippingDiscount.translationParams }}
          } @else {
            {{ shippingDiscount.title }}
          }
          @if (shippingDiscount.code) {
            ({{ shippingDiscount.code }})
          }
        </div>
        <div class="c-green">{{ 0 | currency: order.currency }}</div>
      </div>
    } @else {
      <div class="d-flex justify-content-between m-b-20">
        <div>{{ "order_detail.shipping" | translate }}</div>
        <div>{{ order.shipping | currency: order.currency }}</div>
      </div>
    }
    <div class="d-flex justify-content-between m-b-20">
      <div>{{ "order_detail.tax" | translate }}</div>
      <div>{{ order.tax | currency: order.currency }}</div>
    </div>
    @for (d of lineItemDiscounts; track d.id) {
      <div class="d-flex justify-content-between m-b-20">
        <div>
          @if (d.translationKey) {
            {{ d.translationKey | translate: d.translationParams }}
          } @else {
            {{ d.title }}
          }
          @if (d.code) {
            <span class="discount-pill">{{ d.code }}</span>
          }
        </div>
        @if (d.amount != null && d.amount > 0) {
          <div class="c-green">-{{ d.amount | currency: order.currency }}</div>
        }
      </div>
    }
    @for (p of order.paymentLineItems; track p.id) {
      <div class="d-flex justify-content-between m-b-20">
        <div>
          @if (p.translationKey) {
            {{ p.translationKey | translate }}
          } @else {
            {{ p.title }}
          }
          @if (p.lastFourDigits) {
            (****{{ p.lastFourDigits }})
          }
        </div>
        <div class="c-green">-{{ p.amount | currency: order.currency }}</div>
      </div>
    }
    @if (refundedTotal > 0) {
      <div class="d-flex justify-content-between m-b-20">
        <div>{{ "order_detail.refunded" | translate }}</div>
        <div class="c-red">-{{ refundedTotal | currency: order.currency }}</div>
      </div>
    }
    <hr class="m-y-20" />
    <div class="d-flex justify-content-between m-b-20 bold">
      <div>{{ "order_detail.total" | translate }}</div>
      <div>{{ summaryTotal | currency: order.currency }}</div>
    </div>
    <hr class="m-y-20" />

    @if (order.billingAddress || order.shippingAddress) {
      <div class="row">
        @if (order.shippingAddress) {
          <div class="col-6">
            <div class="secondary-content-bg p-10 m-b-20">
              <div class="bold">{{ "order_detail.shipping_address" | translate }}</div>
              <div class="m-t-10">
                {{ order.shippingAddress.firstName }} {{ order.shippingAddress.lastName }}
                <br />
                {{ order.shippingAddress.address1 }} {{ order.shippingAddress.address2 }}
                <br />
                {{ order.shippingAddress.city }}, {{ order.shippingAddress.province }} {{ order.shippingAddress.zip }}
                <br />
                {{ order.shippingAddress.country }}
                <br />
                {{ order.shippingAddress.phone }}
              </div>
            </div>
          </div>
        }
        @if (order.billingAddress) {
          <div class="col-6">
            <div class="secondary-content-bg p-10 m-b-20">
              <div class="bold">{{ "order_detail.billing_address" | translate }}</div>
              <div class="m-t-10">
                {{ order.billingAddress.firstName }} {{ order.billingAddress.lastName }}
                <br />
                {{ order.billingAddress.address1 }} {{ order.billingAddress.address2 }}
                <br />
                {{ order.billingAddress.city }}, {{ order.billingAddress.province }} {{ order.billingAddress.zip }}
                <br />
                {{ order.billingAddress.country }}
                <br />
                {{ order.billingAddress.phone }}
              </div>
            </div>
          </div>
        }
      </div>
    }

    @if (order.fulfillments?.length) {
      <div class="row">
        @for (fulfillment of order.fulfillments; track fulfillment) {
          @if (fulfillment.trackingInfo?.length) {
            <div class="col-6">
              <div class="secondary-content-bg p-10">
                @for (tracking of fulfillment.trackingInfo; track tracking) {
                  <div class="m-b-20">
                    <div class="bold">{{ "order_detail.tracking_info" | translate: { company: tracking.company } }}</div>
                    <div class="m-t-10">
                      {{ "order_detail.tracking_number" | translate }}
                      <a href="{{ tracking.url }}" target="_blank">{{ tracking.number }}</a>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
</div>
